/**
 * @generated SignedSource<<3f66f545cddd2017330d59321f7d1a0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LoginInput = {
  email: string;
  password: string;
};
export type Login_login_Mutation$variables = {
  input: LoginInput;
};
export type Login_login_Mutation$data = {
  readonly login: {
    readonly token: string;
  } | null;
};
export type Login_login_Mutation = {
  response: Login_login_Mutation$data;
  variables: Login_login_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LoginPayload",
    "kind": "LinkedField",
    "name": "login",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Login_login_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Login_login_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b9598d36fa594280f2756a64e1f4ca91",
    "id": null,
    "metadata": {},
    "name": "Login_login_Mutation",
    "operationKind": "mutation",
    "text": "mutation Login_login_Mutation(\n  $input: LoginInput!\n) {\n  login(input: $input) {\n    token\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c1c0c178bf0df70c27936e860d18cb8";

export default node;
